import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux";
import { AgentEnvironment, agentEnvironmentActions } from "../../redux/reducers/agentEnvironmentSlice";
import { Button, Dialog, DropdownField, InputField, View } from "../base";
import { Icon } from "../base/Icon";

type CreateAgentEnvironmentDialogProps = {
  agentId: string;
  isOpen?: boolean;
  onClose?: () => void;
};

export const CreateAgentEnvironmentDialog = ({ agentId, isOpen = false, onClose = () => {} }: CreateAgentEnvironmentDialogProps) => {
  const dispatch = useAppDispatch();
  const [newEnvironment, setNewEnvironment] = useState<Partial<AgentEnvironment>>({});
  const isLoading = useAppSelector((state) => state.agentEnvironment.isLoadingCreate);
  const agentFunctions = useAppSelector((state) => Object.values(state.agentFunction.entities).filter((env) => env.agentId === agentId));

  const onClickCreateEnvironment = async () => {
    await dispatch(
      agentEnvironmentActions.create({
        agentId,
        name: newEnvironment.name,
        functionId: newEnvironment.functionId || "",
      }),
    );

    onClose();
    setNewEnvironment({ name: "", functionId: "" });
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Environment"
      className="w-full max-w-2xl max-h-[90vh] overflow-y-auto"
    >
      <View className="space-y-4 p-4">
        <InputField
          label="Name"
          value={newEnvironment.name}
          onChange={(value) => setNewEnvironment({ ...newEnvironment, name: value })}
          placeholder="Enter environment name"
        />
        <DropdownField
          label="Function"
          value={newEnvironment.functionId}
          placeholder="Select function"
          onChange={(value) => setNewEnvironment({ ...newEnvironment, functionId: value })}
          options={agentFunctions.map((agentFunction) => ({
            label: agentFunction.displayName || agentFunction.name,
            value: agentFunction.id,
          }))}
        />
        <View className="flex justify-end gap-2">
          <Button
            variant="neutral"
            size="auto"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            size="auto"
            onClick={onClickCreateEnvironment}
            disabled={isLoading || !newEnvironment.name}
          >
            <Icon
              name="add"
              size={14}
            />
            {isLoading ? "Creating..." : "Create Environment"}
          </Button>
        </View>
      </View>
    </Dialog>
  );
};
